
import Vue from 'vue'
import * as Api from '@/api/PartyIdentityUserApi'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import { SubscriptionDto } from '@ViewModels/SubscriptionDto'
import { SaveButton, StandardButton, AddButton } from '@/components/buttons'
import Subscription from './Subscription.vue'
import CreateSubscription from './CreateSubscription.vue'

export default Vue.extend({
   name: 'UserSubscriptions',
   props: { schoolId: String, editingItem: Object as () => PartyIdentityUserDto },
   data() {
      return {
         subscriptions: [] as SubscriptionDto[],
         editingSubscription: null as SubscriptionDto | null,
         creatingSubscription: false,
         loading: true,
         processing: false,
         processed: false,
      }
   },
   computed: {
      isEditing(): boolean {
         return this.editingSubscription != null
      },
   },
   mounted() {
      this.loadSubscriptions()
   },
   methods: {
      edit(sub: SubscriptionDto) {
         this.editingSubscription = sub
      },
      async loadSubscriptions() {
         this.loading = true
         this.subscriptions = await Api.getUserSubscriptions(this.editingItem.Id)
         this.editingSubscription = null
         this.loading = false
      },
      async create() {
         this.creatingSubscription = true
      },
   },
   components: {
      SaveButton,
      StandardButton,
      AddButton,
      Subscription,
      CreateSubscription,
   },
})
